export default function () {
    // run glide slider
    document.addEventListener('DOMContentLoaded', () => {
        const $logosliderItems = document.querySelectorAll('.glide.ce__isnack-logoslider-slider-brands');

        if (!$logosliderItems.length) {
            return;
        }

        $logosliderItems.forEach((slider) => {
            const $slides = slider.querySelectorAll('#' + slider.id + ' .glide__slide');

            // only initialize a slider when we have more than one slide
            if ($slides.length > 1) {
                // responsive/breakpoints settings
                const gapItem = 24;
                const slidesPerViewDesktop = 4;
                const slidesPerViewTablet = 2;
                const slidesPerViewMobile = 1;

                // set autoplay
                const current = document.querySelector('#' + slider.id);
                let intval = 5000;
                // eslint-disable-next-line prefer-destructuring
                const autoplay = parseInt(current.dataset.autoplay, 2); // radix base 2 for bool, base 10 for integer
                if (autoplay === 1) {
                    intval = 5000;
                } else {
                    intval = 0;
                }

                const $logosliderGlide = new Glide('#' + slider.id, {
                    type: 'carousel',
                    // eslint-disable-next-line prefer-destructuring
                    autoplay: intval,
                    animationDuration: 1000,
                    gap: gapItem,
                    perView: slidesPerViewDesktop,
                    breakpoints: {
                        992: {
                            perView: slidesPerViewTablet,
                        },
                        576: {
                            perView: slidesPerViewMobile,
                        },
                    },
                });

                $logosliderGlide.mount();
            }
        });
    });
}
